import React, { useState, useContext } from 'react';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import StyledAppSidebar from './AppSidebar.styles';

import { AppLayoutContext } from '../../../contexts/AppLayout/AppLayoutProvider';

const AppSidebar: React.FC = (): React.ReactElement => {
    const { Sider } = Layout;
    const [siderState, setSiderState] = useState<boolean>(false);

    const {
        state: { sidebarMenuItems },
        state: { sidebarSelectedMenuItemKey },
    } = useContext(AppLayoutContext);

    return (
        <StyledAppSidebar>
            <Sider
                theme="light"
                width="200"
                breakpoint="lg"
                collapsible
                collapsed={siderState}
                onCollapse={(): void => setSiderState(!siderState)}
                className="app-sidebar"
            >
                <Menu
                    theme="light"
                    selectedKeys={[sidebarSelectedMenuItemKey]}
                    mode="inline"
                    className="pt-4 app-sidebar__menu"
                >
                    {sidebarMenuItems.map((menuItem) => (
                        <Menu.Item key={menuItem.key} icon={menuItem.icon} className={menuItem.className}>
                            <Link to={menuItem.pathToName} title={menuItem.text}>
                                {menuItem.text}
                            </Link>
                        </Menu.Item>
                    ))}
                </Menu>
            </Sider>
        </StyledAppSidebar>
    );
};

export default AppSidebar;
